var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "up-arrow",
    width: 23.132,
    height: 23.132,
    viewBox: "0 0 23.132 23.132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#b9c9d9}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_287"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_80",
    cx: 10.709,
    cy: 10.709,
    r: 10.709,
    className: "cls-1",
    transform: "translate(0.857 0.857)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    d: "M11.566 23.132a11.566 11.566 0 1 1 11.566-11.566 11.579 11.579 0 0 1-11.566 11.566zm0-21.34a9.774 9.774 0 1 0 9.774 9.774 9.785 9.785 0 0 0-9.774-9.774z",
    className: "cls-1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_580",
    fill: "#fff",
    d: "M148.373 183.992a.857.857 0 0 1-1.209 0l-3.677-3.677-3.677 3.677a.857.857 0 0 1-1.209-1.209l4.286-4.286a.857.857 0 0 1 1.209 0l4.286 4.286a.857.857 0 0 1-.009 1.209z",
    transform: "translate(-131.91 -170.066)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.782ff72d673e683e5682a1767cd49e35.svg";
export { ForwardRef as ReactComponent };